import { Address } from '../../../interfaces/Address';
import { AddressBehaviourDto } from '../../../interfaces/dtos/AddressBehaviourDto';
import { AddressDto } from '../../../interfaces/dtos/AddressDto';

export default function transformAddress(dto: AddressDto, behaviours: AddressBehaviourDto): Address {
  return {
    behaviours: {
      isUpdateEnabled: behaviours.isUpdateEnabled,
      message: behaviours.message,
      reason: behaviours.reason,
      showSection: behaviours.showSection,
    },
    city: dto.city,
    civicNumber: dto.civicNumber,
    country: dto.country,
    postalCode: dto.postalCode,
    province: dto.province,
    street: dto.street,
    appartementOrSuite: dto.appartementOrSuite,
    appartementOrSuiteType: dto.appartementOrSuiteType,
    deliveryMethod: dto.deliveryMethod,
    postOfficeBox: dto.postOfficeBox,
    externalPlace: dto.externalPlace,
  };
}
